import script from "./contentTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./contentTemplate.vue?vue&type=script&setup=true&lang=js"

import "./contentTemplate.vue?vue&type=style&index=0&id=7815e7a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7815e7a2"]])

export default __exports__